import { Component, Input } from '@angular/core';

/**
 * 2026 redesign hero (docs/2026c-redesign.html `.hero`).
 * Project CTA buttons/links into the default slot; use [aside] for an optional right-column visual.
 */
@Component({
  selector: 'app-hero-v2026',
  templateUrl: './hero-v2026.component.html',
  styleUrl: './hero-v2026.component.scss'
})
export class HeroV2026Component {
  @Input() eyebrow = '';
  /** Named `heading` (not `title`) so it doesn't become a native title-attribute tooltip on the host. */
  @Input() heading = '';
  /** Rendered after `heading` as an emphasized fragment, e.g. heading="Invest in line with your" highlight="Faith". */
  @Input() highlight = '';
  @Input() lede = '';
  /** 'default' = light blue gradient; 'dark' = navy band with white text. */
  @Input() variant: 'default' | 'dark' = 'default';
  /** Set when the page's H1 lives elsewhere so the hero uses a <p> instead of <h1>. */
  @Input() headingLevel: 'h1' | 'p' = 'h1';
}
